import StaffMemberProfessionalBackground from './StaffMemberProfessionalBackground.container';

export default StaffMemberProfessionalBackground;
